import { GoogleMapProps } from '@react-google-maps/api';
import { TResponseStatus } from './common';
import { TMVPChartFilters } from './mvpCharts';
import dayjs from 'dayjs';

export const libraries = [
  'places',
  'geometry',
  'visualization',
  'drawing',
];

export const center = {
  lat: 17.1623717,
  lng: 79.9196817,
};

export type polygonType = {
  lat: number;
  lng: number;
};

export const DEFAULT_MAP_OPTIONS = {
  disableDefaultUI: false,
  draggable: false,
  zoomControl: false,
  rotateControl: true,
  streetViewControl: false,
  fullscreenControl: false,
  keyboardShortcuts: false,
  mapTypeControl: false,
  disableDoubleClickZoom: true,
  mapTypeId: 'hybrid',
  mapTypeIds: ['satellite', 'roadmap', 'hybrid', 'terrain'],
  zoom: 19,
};

export const popupMapOptions = {
  disableDefaultUI: false,
  draggable: true,
  zoomControl: true,
  rotateControl: true,
  streetViewControl: false,
  fullscreenControl: false,
  keyboardShortcuts: true,
  mapTypeControl: false,
  disableDoubleClickZoom: false,
  mapTypeId: 'hybrid',
  mapTypeIds: ['satellite', 'roadmap', 'hybrid', 'terrain'],
  zoom: 18,
};

export const containerStyle = {
  width: '100%',
  height: '100%',
};

export type PolygonUnitType = {
  polygonCoords: polygonType[];
};

export type TFilterData = {
  data?: {
    GetDataForTimeRangeWithFilters?: {
      responseStatus?: TResponseStatus;
      fieldNumbers?: number[];
      dates?: string[];
      dateFieldsJson?: string;
      tableDataType?: string;
      daysAfterPlanting?: number;
    };
  };
};

export type TMVPMapFilterType =
  | 'FILTER_FIELD_NUMBER'
  | 'FILTER_DATE';

export type TMVPMapFilters = TMVPChartFilters & {
  filterTypes: TMVPMapFilterType[];
};

export type TMVPMapGetFarmDataFilters = TMVPChartFilters & {
  fieldNumbers: number[];
  tableDataType?: string;
  daysAfterPlanting?: number;
  indexSelected?: string;
  selectedIndex?: string;
};

export type TFieldMapData = {
  fieldNumber?: number;
  fieldDetails?: {
    registeredArea?: number;
    geofenceArea?: number;
    areaUnderReported?: number;
    growerName?: string;
    lotNo?: number;
    harvestTime: {
      seconds: number;
    };
    employeeData?: {
      fa?: string;
      organizer?: string;
      tpm?: string;
      regionManager: string;
    };
    geographyData?: {
      region?: string;
      village?: string;
    };
    hybridCode: string;
    crop: string;
  };
  fieldGeomData?: {
    geometry?: string;
  };
  fieldIndexList?: Array<{
    presignedS3TiffUrl?: string;
    indexName?: string;
    averageIndex?: number;
    cloudCoverPercentage?: number;
    indexTime?: {
      seconds?: number;
      nanos?: number;
    };
  }>;
};

export type TGetFieldDataForFieldNosResponse = {
  data?: {
    GetFieldDataForFieldNos?: {
      responseStatus?: TResponseStatus;
      fieldDataList?: Array<TFieldMapData>;
    };
  };
};

export type TMapProps = {
  indexName: string | null;
  geometryHex: string;
  tiffFileUrl: string;
  selectedDate?: dayjs.Dayjs;
  setCenterValue?: any;
} & Partial<GoogleMapProps>;

export type TDialogFieldMapData = TMapProps & {
  fieldNumber: number;
  averageIndex: number | undefined;
  cloudCoverPercentage: number | undefined;
};

export type TValidateUserData = {
  data?: {
    ValidateUser?: {
      responseStatus?: TResponseStatus;
      username?: string;
      name?: string;
      actorDetails: {
        actorId: number;
        actorName: string;
        actorType: string;
      };
      countryName: string;
    };
  };
};
